import MinCostPerSquareFoot from "./MinCostPerSquareFoot";

export default class MinCostPerSquareFootWithId extends MinCostPerSquareFoot {
    
    public id: number | null = null;
    
    public constructor() {
        super();
    }
}